import React, { memo } from 'react'
import { Button, Input, Loading, SelectAnimalFetchInput } from 'src/components'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useStyles } from './styles'
import { GenotypingDto, UpdateGenotypingDto } from 'src/dto/genotyping.dto'
import { useRegister } from './hooks/useRegister'
import { VALIDATIONS } from 'src/@types/validations'

interface GenotyRegisterProps {
  onClose: () => void
  data: GenotypingDto | null
}

interface FormattedOption {
  id: string
  value: string
}

const GenotyRegisterComponent = ({ onClose, data }: GenotyRegisterProps) => {
  const {
    watch,
    setValue,
    clearErrors,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<UpdateGenotypingDto>({ resolver: yupResolver(VALIDATIONS.Genotyping) })

  const { isLoading, onSubmit, handleKeyDown } = useRegister({
    data,
    handleSubmit,
    onClose,
    reset
  })

  const style = useStyles()

  if (isLoading) {
    return <Loading />
  }

  return (
    <form onSubmit={async (formData) => await onSubmit(formData)} onKeyDown={handleKeyDown}>
      <div className={style.formInputContainer}>
        <Input
          className={style.formInput}
          type='text'
          label='Cod. Barras'
          value={watch('codigoBarras')}
          error={errors?.codigoBarras?.message}
          onChange={(item: string) => {
            setValue('codigoBarras', item)
            clearErrors('codigoBarras')
          }}
        />
        <SelectAnimalFetchInput
          className={style.formInput}
          label='Animal'
          selectBy='id'
          showBy={['cdn', 'nome']}
          value={watch('idAnimal') || ''}
          error={errors?.idAnimal?.message}
          placeholder='Selecionar Animal'
          onChange={(item: FormattedOption) => {
            setValue('idAnimal', item.id)
            clearErrors('idAnimal')
          }}
        />
      </div>
      <div className={style.formFooter}>
        <Button type='button' outlined onClick={onClose}>
          Cancelar
        </Button>
        <Button type='submit'>{data?.id ? 'Atualizar' : 'Salvar'}</Button>
      </div>
    </form>
  )
}

export default memo(GenotyRegisterComponent)
